import {
  AddPanelCollectionlist64Icon,
  ElementCollectionBlockIcon as CollectionBlockIcon,
  ElementCollectionItemIcon as CollectionItemIcon,
  ElementCollectionListIcon as CollectionListIcon,
  ElementCollectionDefaultIcon as CollectionIcon,
  FilterIcon,
  ListSmallIcon,
  SortIcon,
} from '@packages/systems/spring';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import DynamoWrapper from './DynamoWrapper';
import DynamoList from './DynamoList';
import DynamoItem from './DynamoItem';
import DynamoEmpty from './DynamoEmpty';
import InterimLegacyRichTextValue from './InterimLegacyRichTextValue';

import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';

const CollectionListAddPanelIcon = wrapAddPanelIcon(
  AddPanelCollectionlist64Icon
);

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EList,
  EEnum,
  EUnion,
} from '@packages/systems/wfdl-ast';

export {getCollectionIds, makeCollectionListPropTypes} from './dataTypeCreator';

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelCollectionList: CollectionListAddPanelIcon,
    Collection: CollectionIcon,
    CollectionBlock: CollectionBlockIcon,
    CollectionItem: CollectionItemIcon,
    CollectionList: CollectionListIcon,
    Filter: FilterIcon,
    Sort: SortIcon,
    Curated: ListSmallIcon,
  },
  atoms: {
    DynamoWrapper,
    DynamoList,
    DynamoItem,
    DynamoEmpty,
    InterimLegacyRichTextValue,
  },
  stateAtom: 'DynamoWrapper',
  elementPresets: {
    DynamoWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Dynamo'), iconName('CollectionList')),
        medium: qualify(
          Plugins.name('Dynamo'),
          iconName('AddPanelCollectionList')
        ),
      },
      label: 'Collection List',
      dynamic: true,
      factory: EElement({
        id: 'Dynamo Wrapper',
        type: qualify(Plugins.name('Dynamo'), Component.name('DynamoWrapper')),
        data: ERecord({
          tag: EEnum('div'),
          dyn: ERecord({
            type: EText('wrapper'),
            // Empty query keys match DynamoWrapper dyn.query DataType defaults
            // and handleBindingContextChanged.setEmptyQuery so create + reify
            // share one shape and secondary-locale Binding installs update existing paths.
            query: ERecord({
              usePrimaryLocale: EBoolean(false),
              sort: EList([]),
              filter: ERecord({
                filterFor: EText('ALL'),
                fields: EList([]),
              }),
              curated: ERecord({
                itemIds: EList([]),
              }),
            }),
          }),
          temp: ERecord({
            collectionListItemsPreviewEnabled: EUnion({
              tag: 'GlobalDefault',
              value: ERecord({}),
            }),
            collectionListItemsPreviewCount: ENumber(3),
          }),
          children: EList([
            EElement({
              id: 'Dynamo List',
              type: qualify(
                Plugins.name('Dynamo'),
                Component.name('DynamoList')
              ),
              data: ERecord({
                tag: EEnum('div'),
                dyn: ERecord({
                  type: EText('list'),
                }),
                children: EList([
                  EElement({
                    id: 'Dynamo Item',
                    type: qualify(
                      Plugins.name('Dynamo'),
                      Component.name('DynamoItem')
                    ),
                    data: ERecord({
                      dyn: ERecord({
                        type: EText('item'),
                        grid: ENumber(12),
                      }),
                      children: EList([]),
                    }),
                  }),
                ]),
              }),
            }),
            EElement({
              id: 'Dynamo Empty',
              type: qualify(
                Plugins.name('Dynamo'),
                Component.name('DynamoEmpty')
              ),
              data: ERecord({
                tag: EEnum('div'),
                dyn: ERecord({
                  type: EText('empty'),
                }),
                children: EList([
                  EElement({
                    id: 'Dynamo Wrapper Block',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Block')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      text: EBoolean(true),
                      children: EList([
                        EElement({
                          id: 'Dynamo Wrapper String',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('No items found.'),
                        }),
                      ]),
                    }),
                  }),
                ]),
              }),
            }),
          ]),
        }),
      }),
      helpData: {
        description: [
          'A Collection list pulls content — like colors, text, and images — from a CMS collection to use across your site',
          'All styles applied to a Collection list will affect each item in that list. But you can still customize them with sorts and filters.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/d2/collection-list.eb3fbaef45.mp4',
      },
      category: 'CMS',
    }),
  },
});
